import React from 'react';
import { Container } from 'styles';
import Sticky from 'react-sticky-el';
import { Selector } from '../selector';
import { Content } from '../content';
import { Background } from './mobile.style';

export const Mobile = () => (
  <Background data-testid="mobile-usage">
    <Sticky stickyStyle={{ zIndex: 1 }}>
      <Selector />
    </Sticky>
    <Container>
      <Content />
    </Container>
  </Background>
);
